module.exports = __webpack_public_path__ + "img/ic_loading.09f8c642.svg";